<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo-white.svg"
          class="logo-light"
          width="200"
          alt="Smile Magazine Logo"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->
    <!-- Start 404 Page  -->
    <div class="error-page-inner bg_color--4">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="inner">
              <h1 class="heading-title theme-gradient">404!</h1>
              <h3 class="sub-title">Pagina no encontrada</h3>
              <span>Ups! Parace que la pagina que buscas ya no encuentra disponible.</span>
              <div class="error-button">
                <router-link class="rn-button-style--2 btn_solid" to="/"
                  >Ir a la página principal</router-link
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End 404 Page  -->
    <Footer style="background-color: #1A1B1F;"/>
  </div>
</template>

<script>
  import Header from '../layout/header/HeaderOnePage.vue';
  import Footer from "../layout/footer/Footer.vue";
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {};
    },
  };
</script>
